import "./SettingDropdown.css";
import { setCurrentTab } from "../../../redux/links/linksSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Arrow from "../../../assets/images/rightAnglePath.svg";
import React, { useState, useEffect, useRef } from "react";
import {
  globalCurrentPageTitle,
  showPayoutDetailsAtom,
} from "../../../store/globalstore";
import { useAtom } from "jotai";
import { toastify } from "../../../helpers/toast/toastify";

const SettingDropdown = () => {
  const user = useSelector((e) => e?.user?.user);
  const [, setCurrentPageTitle] = useAtom(globalCurrentPageTitle);
  const [_, setShowPayoutDetails] = useAtom(showPayoutDetailsAtom);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target))
      setIsOpen(false);
  };

  const handleOptionClick = () => setIsOpen(false);
  const toggleDropdown = () => {
    setIsOpen((prev) => !prev)
     
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <div className="setting-dropdown" ref={dropdownRef}>
      <button
        className={`dropdown-toggle ${isOpen ? "active" : ""}`}
        onClick={toggleDropdown}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="21"
          viewBox="0 0 23.532 23.527"
        >
          <path
            d="M11.753 23.527c-.453 0-.905-.026-1.355-.077a1.273 1.273 0 0 1-1.123-1.335 1.814 1.814 0 0 0-1.103-1.774 1.91 1.91 0 0 0-2.035.471 1.275 1.275 0 0 1-1.737.139 11.824 11.824 0 0 1-1.86-1.882 1.27 1.27 0 0 1 .138-1.718c.563-.51.75-1.315.47-2.021a1.783 1.783 0 0 0-1.668-1.123h-.03c-.602 0-1.301-.432-1.374-1.127a11.828 11.828 0 0 1 0-2.675 1.254 1.254 0 0 1 1.296-1.122 1.93 1.93 0 0 0 1.812-1.104c.29-.71.102-1.525-.47-2.035a1.275 1.275 0 0 1-.123-1.748c.559-.7 1.198-1.331 1.903-1.882a1.278 1.278 0 0 1 1.723.143c.523.54 1.313.724 2.02.47a1.821 1.821 0 0 0 1.118-1.745 1.273 1.273 0 0 1 1.13-1.31c.88-.098 1.768-.095 2.647.009a1.268 1.268 0 0 1 1.122 1.33 1.819 1.819 0 0 0 1.104 1.773c.711.262 1.51.077 2.035-.47a1.27 1.27 0 0 1 1.736-.127 11.678 11.678 0 0 1 1.866 1.882 1.278 1.278 0 0 1-.139 1.722 1.802 1.802 0 0 0 1.24 3.139c.593 0 1.283.433 1.36 1.127.101.889.101 1.786 0 2.675a1.277 1.277 0 0 1-1.336 1.125h-.115A1.802 1.802 0 0 0 20.8 17.4c.494.45.557 1.206.143 1.732-.56.698-1.199 1.33-1.903 1.882a1.266 1.266 0 0 1-1.715-.143 1.922 1.922 0 0 0-2.026-.47 1.817 1.817 0 0 0-1.118 1.74 1.27 1.27 0 0 1-1.13 1.306c-.43.05-.864.077-1.298.08m-1.176-1.37c.762.086 1.531.086 2.294 0a3.118 3.118 0 0 1 1.924-2.964 3.214 3.214 0 0 1 3.466.772 10.45 10.45 0 0 0 1.647-1.63 3.108 3.108 0 0 1-.762-3.483 3.146 3.146 0 0 1 2.873-1.913h.148c.083-.76.083-1.528 0-2.29a.18.18 0 0 0-.073-.027 3.103 3.103 0 0 1-2.141-5.381 10.227 10.227 0 0 0-1.598-1.621 3.198 3.198 0 0 1-3.482.762 3.12 3.12 0 0 1-1.91-3.019 10.358 10.358 0 0 0-2.295 0 3.127 3.127 0 0 1-1.924 2.965 3.214 3.214 0 0 1-3.461-.767 10.45 10.45 0 0 0-1.647 1.63 3.122 3.122 0 0 1 .762 3.487 3.224 3.224 0 0 1-3.021 1.908c-.083.76-.083 1.526 0 2.285a.252.252 0 0 0 .087.033 3.082 3.082 0 0 1 2.882 1.918 3.122 3.122 0 0 1-.762 3.456c.475.602 1.016 1.15 1.614 1.63a3.183 3.183 0 0 1 3.482-.762 3.115 3.115 0 0 1 1.91 3.01l-.013.002Zm1.209-6.015a4.358 4.358 0 1 1 4.355-4.36v.002a4.36 4.36 0 0 1-4.355 4.358m0-7.412a3.059 3.059 0 1 0 3.059 3.059 3.059 3.059 0 0 0-3.057-3.061h-.002v.002Z"
            data-name="Path 10779"
            fill-rule="evenodd"
            fill="#000"
          />
        </svg>
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {user?.role === "leader" && user.leaderCommunity && (
            <li
              onClick={() => {
                handleOptionClick();

                if (user?.role === "leader") {
                  navigate("newCopyTrade");
                } else {
                  dispatch(setCurrentTab("subscribe"));
                  navigate("copyTrade");
                  setCurrentPageTitle("");
                }
              }}
            >
              Subscription
              <img alt="Arrow" src={Arrow} />
            </li>
          )}
          <li
            onClick={() => {
              handleOptionClick();

              if (user?.role === "leader" && user?.leaderCommunity) {
                dispatch(setCurrentTab("ExchangeConnection"));
                navigate("newCopyTrade");
              } else if (user?.role === "leader" && user?.tradeName&& !user?.leaderCommunity) {
                dispatch(setCurrentTab("ExchangeConnection"));
                navigate("verifiedTrading");
              } else if (user?.role === "leader" && !user?.tradeName && !user?.leaderCommunity) {
                dispatch(setCurrentTab("ExchangeConnection"));
                navigate("newCopyTrade");
              } else {
                navigate("copyTrade2");
              }
            }}
          >
            
            {user?.role==="leader"?"Connection":"Copy Trade Settings"}
            <img alt="Arrow" src={Arrow} />
          </li>
          {user?.role === "leader" && (
            <li
              onClick={() => {
                if (user?.role === "leader" && user?.leaderCommunity) {
                  handleOptionClick();

                  dispatch(setCurrentTab("AutoShare"));
                  navigate("newCopyTrade");
                } else if (user?.role === "leader" && user?.tradeName&&!user?.leaderCommunity) {
                  handleOptionClick();

                  dispatch(setCurrentTab("AutoShare"));
                  navigate("verifiedTrading");
                }else if (user?.role === "leader" && !user?.tradeName && !user?.leaderCommunity) {
                  handleOptionClick();

                  dispatch(setCurrentTab("AutoShare"));
                  navigate("newCopyTrade");
                }
              }}
            >
              Share results
              <img alt="Arrow" src={Arrow} />
            </li>
          )}
          {user?.role === "leader" && (
            <li
              onClick={() => {
                if (user?.role === "leader" && user?.leaderCommunity) {
                  handleOptionClick();
                  navigate("payment");
                  setCurrentPageTitle("");
                  setShowPayoutDetails(true);
              } else if (user?.role === "leader" && user?.tradeName&&!user?.leaderCommunity) {
                  if(!(user?.verifiedmyTrade?.payment)){
                    toastify("Click on Start Button to Start Performance Verification", "error");
                    return;
                  }
                  handleOptionClick();
                  navigate("verifiedPaymentBillingHistory");
                  setCurrentPageTitle("");
                  setShowPayoutDetails(true);
                }else if (user?.role === "leader" && !user?.tradeName && !user?.leaderCommunity) {
                  handleOptionClick();
                  navigate("payment");
                  setCurrentPageTitle("");
                  setShowPayoutDetails(true);
                }
              }}
            >
              {user?.leaderCommunity ||(!user?.leaderCommunity&&!user?.tradeName) ? "Payment and Payouts": "Payment"}
              <img alt="Arrow" src={Arrow} />
            </li>
          )}
        </ul>
      )}
    </div>
  );
};

export default SettingDropdown;
